<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Placement Process</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Placement Process</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="minority-cell ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col">
        <span>The Placement process</span>
        <blockquote class="blockquote-div mt-3">
          <p>If you can DREAM it, you can DO it
          </p>
          <h6>- Walt Disney</h6>
        </blockquote>
        <p>An aspiring managementaspirant, a technical savvy, a research seeker or a soon-to-be-a triumphant business
          person! Not to obliterate the student associated with the out-of-the-box ideas. This is your ticket to turn
          your dream into reality. You have applied for the best colleges to pursue your degree. Your primaryobjective
          was to have a successful job before you leave the academic education. And, this is what we aim to accomplish
          with theplacement process, at our institute.</p>
        <p>Undoubtedly, from the very first day of your college education you have been on the receiving end of
          knowledge, brushing of skills and co-curricularactivities to enrich your personality. Presently, you are atthe
          first step to the achievement you always aspired to. The pathway to create milestones starts with the
          placement process.</p>
        <h4 class="yellow-color fw-bold">The benefits</h4>
        <p>Our placement process is well- structured to aid the students with maximum advantages. The well deserving
          students will be able to avail with us:-</p>
        <ul>
          <li>1. A job- With the placement process you will be able to have an offer letter in your hand even before you
            have passed out from the college.</li>
          <li>2. Authentic employers- when you are planning to explore the employment industry, you come across a number
            of employers. There are some authentic and some forged. With the stringent process we make sure that the
            authentic employers arrive at the campus for recruitment purpose. Hence, you are on the receiving end of the
            finest experience.</li>
          <li>3. Assistance- whether it is the interview, the group discussion or the written test, you will always be
            guided by our team of professors, teachers and mentors. You will be able to learn a lot in the procedure and
            be industry-ready.</li>
        </ul>
        <h4 class="yellow-color fw-bold">The process</h4>
        <p>The placement process is an opportunity for you to avail that job opportunity you always wanted to. With it
          you will be able to get hold of the position which opens avenues for greater success in the course. The
          stepwise procedure consists of:-</p>
        <ul class="list-before">
          <li><strong>The Affirmation-</strong> the affirmation involves our communication with the Company and
            vice-versa to confirm their arrival for campus recruitment. A screening process from both the ends is ensued
            in the same.</li>
          <li><strong>Allotting the date-</strong> a date is concluded to by the recruiter and us together, for the
            conduction of the initial screening.</li>
          <li>Pre-Placement talk- the students are made aware of the job profile, the position and the skill set the
            company is looking for. They are also provided information about the brand they will be working for, the
            position for which the students are appearing and the number of vacancies the company has. The pre placement
            talk provides the students with the needful information for the aspiring candidates from the company.</li>
          <li><strong>Screening-</strong> the screening consists of a plethora of methods. Some companies short list the
            students on the basis of their CVs. There are others which make the students appear for a written test. And,
            there are still others which have psychometric tests, online tests and group discussions lined up for the
            students.</li>
          <li><strong>Interviews-</strong> this is the pre-final step to the avail a job with the employer. A plethora
            of questions are asked in the interview to select an employee from the list of shortlisted candidates. This
            again depends on the employer to take the course best suited for them. Some go for the Skype interviews.
            There are others which pursue telephonic interviews. And, there are still the ones who take the personal
            interviews. The students simply need to be prepared for each.</li>
          <li><strong>Announcement-</strong> An announcement with regards to the selection of the students is done in
            this step by the recruiters.</li>
          <li><strong>Official communication-</strong> the company then communicates about the same to the selected
            students by the offer letters sent to them.</li>
        </ul>
        <p>Welcome to the onset of a new journey called JOB- it’s worth the entire endeavor you have put up in these
          years of your college. The experience will always be that primary root enriching you with promising
          accomplishments. Best wishes from the Raisoni Group of Colleges to you!</p>
      </div>
    </div>
  </div>
</section>
